module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "Messages-"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMessages),
      expression: "showMessages"
    }],
    staticClass: "Messages",
    class: {
      'Messages--altColors': _vm.altColors,
      'Messages--suiteIsUnoccupied': _vm.suiteIsUnoccupied
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "Messages-item-",
      "tag": "div"
    }
  }, _vm._l((_vm.displayed), function(message, index) {
    return _c('div', {
      key: index,
      ref: "items",
      refInFor: true,
      staticClass: "Messages-item",
      class: {
        'Messages-item--isFirst': index === 0
      }
    }, [_c('div', {
      staticClass: "Messages-itemContent",
      domProps: {
        "innerHTML": _vm._s(message)
      }
    })])
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02071106"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Messages.vue
// module id = 352
// module chunks = 1